import script from "./PaymentDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PaymentDetailsPopup.vue?vue&type=style&index=0&id=ad11576c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad11576c"]])

export default __exports__